// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-chart-page-tsx": () => import("./../src/pages/chart-page.tsx" /* webpackChunkName: "component---src-pages-chart-page-tsx" */),
  "component---src-pages-covid-mdx": () => import("./../src/pages/covid.mdx" /* webpackChunkName: "component---src-pages-covid-mdx" */),
  "component---src-pages-food-chart-tsx": () => import("./../src/pages/food-chart.tsx" /* webpackChunkName: "component---src-pages-food-chart-tsx" */),
  "component---src-pages-home-assistant-mdx": () => import("./../src/pages/home-assistant.mdx" /* webpackChunkName: "component---src-pages-home-assistant-mdx" */),
  "component---src-pages-home-assistant-rebuild-mdx": () => import("./../src/pages/home-assistant-rebuild.mdx" /* webpackChunkName: "component---src-pages-home-assistant-rebuild-mdx" */),
  "component---src-pages-index-tsx": () => import("./../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

